export default (array) => {
	for (let i = array.length - 1; i > 0; i--) {
		const index = Math.floor(Math.random() * (i + 1));
		[array[i], array[index]] = [array[index], array[i]];
	}
};
